import actionTypes from "../constants/actionTypes";

const initialState = {
    menuData: [],
    clickSubMenuItems: [],
    clickSubMenuItem: {},
    isMenu: false
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.MENU_ON_RESULT:
            return {
                ...state,
                menuData: action.menuData.data,
                isMenu: true,
            };
        case actionTypes.MENU_CLICK_RESULT:
            return {
                ...state,
                clickSubMenuItems: action?.clickSubMenuItems,
                clickSubMenuItem: action?.clickSubMenuItem
            };
        default:
            return state;
    }
}
